import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/commerce-webapi/commerce-webapi/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "addwishlistitemstocart-mutation"
    }}>{`addWishlistItemsToCart mutation`}</h1>
    <p>{`The `}<inlineCode parentName="p">{`addWishlistItemsToCart`}</inlineCode>{` mutation moves items from the specified wish list to the customer's cart.`}</p>
    <p>{`This mutation requires a valid `}<a parentName="p" {...{
        "href": "../../customer/mutations/generate-token.md"
      }}>{`customer authentication token`}</a>{`.`}</p>
    <h2 {...{
      "id": "syntax"
    }}>{`Syntax`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-graphql"
      }}>{`mutation {
  addWishlistItemsToCart (
    wishlistId: ID!
    wishlistItemIds: [ID!]
  ) {
    AddWishlistItemsToCartOutput
  }
}
`}</code></pre>
    <h2 {...{
      "id": "reference"
    }}>{`Reference`}</h2>
    <p>{`The `}<a parentName="p" {...{
        "href": "https://developer.adobe.com/commerce/webapi/graphql-api/index.html#query-wishlist"
      }}><inlineCode parentName="a">{`addWishlistItemsToCart`}</inlineCode></a>{` reference provides detailed information about the types and fields defined in this mutation.`}</p>
    <h2 {...{
      "id": "example-usage"
    }}>{`Example usage`}</h2>
    <p>{`The following example moves two items from a wishlist to the cart.`}</p>
    <p><strong parentName="p">{`Request:`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-graphql"
      }}>{`mutation {
  addWishlistItemsToCart(
    wishlistId: 1
    wishlistItemIds: [2, 3])
  {
    status
    add_wishlist_items_to_cart_user_errors {
      code
      message
    }
    wishlist {
      id
      items_v2 {
        items {
          id
          product {
            uid
            sku
            name
          }
        }
      }
    }
  }
}
`}</code></pre>
    <p><strong parentName="p">{`Response:`}</strong></p>
    <pre><code parentName="pre" {...{
        "className": "language-json"
      }}>{`{
  "data": {
    "addWishlistItemsToCart": {
      "status": true,
      "add_wishlist_items_to_cart_user_errors": [],
      "wishlist": {
        "id": "1",
        "items_v2": {
          "items": [
            {
              "id": "1",
              "product": {
                "uid": "MTM=",
                "sku": "24-WB07",
                "name": "Overnight Duffle"
              }
            },
            {
              "id": "4",
              "product": {
                "uid": "MTEwMA==",
                "sku": "WH04",
                "name": "Miko Pullover Hoodie"
              }
            },
            {
              "id": "5",
              "product": {
                "uid": "MTIyOA==",
                "sku": "WJ01",
                "name": "Stellar Solar Jacket"
              }
            },
            {
              "id": "6",
              "product": {
                "uid": "MTcyNA==",
                "sku": "WT03",
                "name": "Nora Practice Tank"
              }
            },
            {
              "id": "7",
              "product": {
                "uid": "MTY5Mg==",
                "sku": "WT01",
                "name": "Bella Tank"
              }
            }
          ]
        }
      }
    }
  }
}
`}</code></pre>
    <h2 {...{
      "id": "errors"
    }}>{`Errors`}</h2>
    <p>{`The `}<inlineCode parentName="p">{`WishlistCartUserInputErrorType`}</inlineCode>{` field can contain the following values:`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`INSUFFICIENT_STOCK`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The requested quantity of a product is greater than the quantity available`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`NOT_SALABLE`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A requested product is not available`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`PRODUCT_NOT_FOUND`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A product with the specified ID does not exist.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`UNDEFINED`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The error message does not match any error code`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      